import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c1-one-one-one-six',
  templateUrl: './c1-one-one-one-six.component.html',
  styleUrls: ['./c1-one-one-one-six.component.scss']
})
export class C1OneOneOneSixComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion 1/1.1.1_CURRICULUM DELIVERY/1.1.1.6_MENTOR GROUPS.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }
}
